<template>
    <div>
        <el-dialog title="加盟商服务合同" :visible.sync="jcxy" :close-on-click-modal="false" width="800px" center
            label-width="100">
            <el-form :inline="true" ref="addForm" :model="reqCreate" label-width="100px" :rules="rules">
                <el-form-item label="签署公司（乙方）" class="item" prop="signSealId">
                    <el-select v-model="reqCreate.signSealId" style="width:635px" @change="selectJms" clearable
                        placeholder="请选择签署公司（乙方）" filterable>
                        <el-option v-for="(item, index) in allJMSList" :key="index" :label="item.companyName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系电话" prop="tel">
                            <el-input v-model="reqCreate.tel" style="width:255px" type="number" clearable maxlength="11"
                                show-word-limit placeholder="签署公司的联系电话"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="信用代码" prop="xinyongdaima">
                            <el-input v-model="reqCreate.xinyongdaima" style="width:255px" clearable show-word-limit
                                placeholder="签署公司的三合一社会信用代码"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-form-item label="联系地址" prop="address">
                        <el-input v-model="reqCreate.address" style="width:635px" show-word-limit placeholder="签署公司的联系地址"
                            clearable></el-input>
                    </el-form-item>
                </el-row>
                <!--el-form-item label="截止日期" prop="dateStart">
                    <el-date-picker v-model="reqCreate.dateStart" type="date" placeholder="合同截止日期"
                        value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width:255px"></el-date-picker>
                    <div style="color: red;font-size: 11px;">本合同的期限为3年，自本合同签订之日起至</div>
                </el-form-item>-->
                <el-row>
                    <el-form-item label="开始日期" prop="dateStart">
                      <el-date-picker v-model="reqCreate.dateStart" style="width:255px" type="date"
                                      placeholder="请选择服务开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="截止日期" prop="dateEnd">
                      <el-date-picker v-model="reqCreate.dateEnd" style="width:255px" type="date" placeholder="请选择服务截止日期"
                                      value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="加盟商户名" prop="collectUserName">
                        <el-input v-model="reqCreate.collectUserName" style="width:255px" clearable show-word-limit
                            placeholder="请输入加盟商户名"></el-input>
                    </el-form-item>
                    <el-form-item label="加盟商账号" prop="collectAccount">
                        <el-input v-model="reqCreate.collectAccount" style="width:255px" clearable show-word-limit
                            placeholder="请输入加盟商账号"></el-input>
                    </el-form-item>
                    <el-form-item label="加盟商开户行" prop="collectBankName">
                        <el-input v-model="reqCreate.collectBankName" style="width:255px" clearable show-word-limit
                            placeholder="请输入加盟商开户行"></el-input>
                    </el-form-item>

                    <el-form-item label="合同日期" prop="htrq">
                        <el-date-picker v-model="reqCreate.htrq" type="datetime" style="width:255px" placeholder="请选择合同签署日期"
                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>

                </el-row>




            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="jcxy = false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>
        </el-dialog>

        <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
            <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0"
                style="width:870px;height:800px"></iframe>

            <span slot="footer" class="dialog-footer">
                <el-button @click="PDFVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import wmsApi from "@/script/api/wmsApi";
import globalData from '@/components/common/globaldata/global.data';
export default {
    data() {
        return {
            id: null,
            jcxy: false,
            PDFVisible: false,
            contractUrl: null,
            allJMSList: [],

            addField: {},
            singList: [],
            choosePerson: {}, //下拉框所选人
            rules: {
                signSealId: [{ required: true, message: "请选择签署公司", trigger: "blur" }],
                tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
                xinyongdaima: [{ required: true, message: "请输入信用代码", trigger: "blur" }],
                address: [{ required: true, message: "请输入联系地址", trigger: "blur" }],
                dateStart: [{ required: true, message: "请选择合同截至时间", trigger: "change" }],
                dateEnd: [{ required: true, message: "请选择合同截至时间", trigger: "change" }],
                htrq: [{ required: true, message: "请选择合同签订日期", trigger: "change" }],
            },
            reqCreate: {
                xinyongdaima: '',
                dateStart: '',
                htrq: '',

                "address": "",
                "collectAccount": "",
                "collectBankName": "",
                "collectUserName": "",
                "contractFileId": "",
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                "dateEnd": "",
                "dateStart": "",
                "feeDate": "",
                "fraId": '',
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "signSealId": '',
                "state": '',
                "storeNumber": '',
                "tel": "",
                "templateNo": "",
                "type": ''
            }
        };
    },
    methods: {
        showDetail() {
            this.getAllJMS();
            this.jcxy = true;

            this.reqCreate = {
                xinyongdaima: '',
                dateStart: '',
                htrq: '',
                "address": "",
                "collectAccount": "",
                "collectBankName": "",
                "collectUserName": "",
                "contractFileId": "",
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                "dateEnd": "",
                "dateStart": "",
                "feeDate": "",
                "fraId": '',
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "signSealId": '',
                "state": '',
                "storeNumber": '',
                "tel": "",
                "templateNo": "",
                "type": ''
            };

        },
        selectJms(id) {
            if (id == null || id == '') {
                this.choosePerson = {};
                this.reqCreate.fraId = "";
                this.reqCreate.xinyongdaima = "";
                this.reqCreate.tel = "";
                this.reqCreate.address = "";
            }
            if (id != null) {
                let ren = {};
                this.allJMSList.forEach(e => {
                    if (e.id == id) {
                        ren = e;
                    }
                })
                this.choosePerson = ren;
                this.reqCreate.fraId = ren.franchiseeId;
                this.reqCreate.xinyongdaima = ren.creditCode;
                this.reqCreate.tel = ren.tel;
                console.log(ren);
                this.reqCreate.address = ren.address;
            }
        },
        fillTemplate() {
            let addField = {
                fraName: this.choosePerson.companyName,
                xinyongdaima: this.reqCreate.xinyongdaima,
                address: this.reqCreate.address,
                tel: this.reqCreate.tel,
                startYear:this.reqCreate.dateStart.substring(0, 4),
                startMonth:this.reqCreate.dateStart.substring(5, 7) * 1,
                startDay:this.reqCreate.dateStart.substring(8, 10) * 1,
                year: this.reqCreate.dateEnd.substring(0, 4),
                month: this.reqCreate.dateEnd.substring(5, 7) * 1,
                day: this.reqCreate.dateEnd.substring(8, 10) * 1,
                collectUserName: this.reqCreate.collectUserName,
                collectAccount: this.reqCreate.collectAccount,
                collectBankName: this.reqCreate.collectBankName,
                jia_year: this.reqCreate.htrq.substring(0, 4),
                jia_month: this.reqCreate.htrq.substring(5, 7) * 1,
                jia_day: this.reqCreate.htrq.substring(8, 10) * 1,
                yi_year: this.reqCreate.htrq.substring(0, 4),
                yi_month: this.reqCreate.htrq.substring(5, 7) * 1,
                yi_day: this.reqCreate.htrq.substring(8, 10) * 1,
                jia: '',
                yi: '',
                Contract_no: ''
            };
            this.addField = addField;
            return addField;
        },
        yulan() {
            this.$refs['addForm'].validate(valid => {
                if (valid) {
                    if (this.reqCreate.tel == null || this.reqCreate.tel == '' || this.reqCreate.tel.length != 11) {
                        this.$message.error('请输入联电话，或输入正确的电话号码');
                        return false;
                    }

                    let temFields = this.fillTemplate();
                    this.reqCreate.tempSignData = temFields;

                    let reqData = {
                        // cityId: this.reqCreate.cityId,
                        fraId: this.reqCreate.fraId,
                        eventType: 201,
                        name: '服务合同',
                        simpleFormFields: temFields
                    };

                    const loading = this.$loading({
                        lock: true,
                        text: '努力生成中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });

                    contract
                        .$ajaxPreviewFile(reqData)
                        .then((res) => {
                            if (res.data.errno == 0) {
                                loading.close();
                                // console.log(res);
                                this.contractUrl = res.data.data.downloadUrl;
                                this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                                this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                                this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                                this.PDFVisible = true;
                            } else {
                                loading.close();
                                this.$message({
                                    showClose: true,
                                    message: res.data.data,
                                    type: 'warning',
                                    duration: 8000
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            });
        },
        sendContractBtn() {
            const loading = this.$loading({
                lock: true,
                text: '发送合同中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            this.reqCreate.fraId = globalData.franchisee.id;
            this.reqCreate.createUserId = this.reqCreate.fraId;// globalData.userInfo.id;
            this.reqCreate.createUserName = globalData.userInfo.userName;
            this.reqCreate.type = 201;

            contract.$ajaxJmsSignContract(this.reqCreate).then((res) => {
                loading.close();
                if (res.data.errno == 0) {
                    this.$message.success('合同已发送！');
                    // this.querySearch();
                    this.$emit('querySearch');
                    this.PDFVisible = false;
                    this.jcxy = false;
                } else {
                    this.$message.warning(res.data.data);
                }
            });
        },
        getAllJMS() {
            //城市下拉框
            contract
                .$ajaxJmsgetJMSAll()
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.allJMSList = res.data.data;
                    }
                });
        },
    }
};
</script>
<style lang="">
.item .el-form-item__label{
    color:#f56c6c;
     font-weight:bold;
     font-size:10px
  }
</style>
